import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Companion_getInstance23x6zslwzj0st as Companion_getInstance,
  Companion_getInstance2h9rm1uihk6zf as Companion_getInstance_0,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  KProperty1ca4yb4wlo496 as KProperty1,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
  Signal1973xs1vkmdcb as Signal,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  CompactSemantic_getInstance3lxnpjuev524m as CompactSemantic_getInstance,
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  ListSemantic_getInstance2e62q1se6gw64 as ListSemantic_getInstance,
  UnselectedSemantic_getInstance1xc7cb2k39ftl as UnselectedSemantic_getInstance,
  SelectedSemantic_getInstance3adr60xrkcq3z as SelectedSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  themed2vu67ornd4jps as themed,
  dynamicThemed3lsusnjffkq9e as dynamicThemed,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { MenuButton27en4jjgdkozz as MenuButton } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/MenuButton.commonHtml.mjs';
import {
  isBlank1dvkhjjvox3p0 as isBlank,
  contains3ue2qo8xhmpf1 as contains,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { subtext2yjmf1ok7kb40 as subtext } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
  get_scrolling3fwkltztkpfe8 as get_scrolling,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { sortedWith2csnbbb21k0lg as sortedWith } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import {
  Button$_get_accessibleLabel_$ref_o692ls1vhc8yibu26ff as Button$_get_accessibleLabel_$ref_o692ls,
  Button$_set_accessibleLabel_$ref_xk4qh0quoqz7irbbbf as Button$_set_accessibleLabel_$ref_xk4qh0,
} from './multiselect.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { colOfv2oygjkn5hb2 as colOf } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/lists.mjs';
import { closePopoversckn4u815mr3s as closePopovers } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/ViewContextExtensions.mjs';
import {
  orPromise1iucc2to2udt2 as orPromise,
  $3l5vvh8yg0ier as $,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { await1uwe8zvsjq69o as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function singleSelect(_this__u8e3s4, edit, options, toString, hint, icon, row) {
  hint = hint === VOID ? '' : hint;
  icon = icon === VOID ? Companion_getInstance().add_1 : icon;
  var tmp;
  if (row === VOID) {
    tmp = (_this__u8e3s4, it) => {
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
      ensureOutermostElement(element);
      _this__u8e3s4.willAddChild_hz2iwc_k$(element);
      var tmp = KMutableProperty0();
      var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
      var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
      element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => toString($this$invoke.invoke_r7m7el_k$(it)));
      element.onStartup_vrxh3i_k$();
      _this__u8e3s4.addChild_2qpft2_k$(element);
      return Unit_instance;
    };
  } else {
    tmp = row;
  }
  row = tmp;
  var tmp_0 = _Constant___init__impl__v45mub(true);
  var tmp_1 = KProperty1();
  return singleSelectToggleWithId(_this__u8e3s4, new (Constant())(tmp_0), edit, options, getPropertyCallableRef('_id', 1, tmp_1, HasId$_get__id_$ref_bvv61j(), null), toString, hint, icon, row);
}
function singleSelectToggleWithId(_this__u8e3s4, editMode, edit, options, id, toString, hint, icon, row) {
  hint = hint === VOID ? '' : hint;
  icon = icon === VOID ? Companion_getInstance().add_1 : icon;
  var tmp;
  if (row === VOID) {
    tmp = (_this__u8e3s4, it) => {
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
      ensureOutermostElement(element);
      _this__u8e3s4.willAddChild_hz2iwc_k$(element);
      var tmp = KMutableProperty0();
      var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
      var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
      element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => toString($this$invoke.invoke_r7m7el_k$(it)));
      element.onStartup_vrxh3i_k$();
      _this__u8e3s4.addChild_2qpft2_k$(element);
      return Unit_instance;
    };
  } else {
    tmp = row;
  }
  row = tmp;
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'kotlin.let' call
  var it = weight(element, 1.0);
  var tmp_0;
  if (equals(editMode, new (Constant())(_Constant___init__impl__v45mub(true)))) {
    tmp_0 = it;
  } else {
    tmp_0 = shownWhen(it, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(editMode));
  }
  // Inline function 'com.lightningkite.kiteui.views.compact' call
  var this_0 = tmp_0;
  // Inline function 'com.lightningkite.kiteui.views.direct.menuButton' call
  var this_1 = themed(this_0, CompactSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (MenuButton())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_1.willAddChild_hz2iwc_k$(element_0);
  element_0.requireClick_1 = true;
  element_0.set_preferredDirection_gql2kx_k$(Companion_getInstance_0().belowRight_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_2 = shownWhen(element_0, VOID, VOID, ($this$shownWhen) => !($this$shownWhen.invoke_r7m7el_k$(edit) == null));
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_2.willAddChild_hz2iwc_k$(element_1);
  var tmp_1 = KMutableProperty0();
  var tmp_2 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_3 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_3, ($this$invoke) => {
    var selectedId = $this$invoke.invoke_r7m7el_k$(edit);
    var tmp0 = $this$invoke.invoke_r7m7el_k$(options);
    var tmp$ret$17;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var element = _iterator__ex2g4s.next_20eer_k$();
        if (!(selectedId == null) && equals(id(element), selectedId)) {
          tmp$ret$17 = element;
          break $l$block;
        }
      }
      tmp$ret$17 = null;
    }
    var tmp0_safe_receiver = tmp$ret$17;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = toString(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
  });
  element_1.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_1);
  // Inline function 'kotlin.text.isNotBlank' call
  if (!isBlank(hint)) {
    subtext(shownWhen(element_0, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(edit) == null), hint);
  }
  element_0.opensMenu_gggyad_k$(($this$opensMenu) => {
    singleSelector($this$opensMenu, options, edit, singleSelectToggleWithId$lambda$slambda(edit, id, $this$opensMenu), id, toString, row);
    return Unit_instance;
  });
  element_0.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_0);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
}
function singleSelector(_this__u8e3s4, options, selected, select, id, toString, row) {
  var search = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$('');
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_0 = sizeConstraints(_this__u8e3s4, VOID, VOID, VOID, VOID, VOID, get_rem(20), get_rem(20));
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  var this_1 = themed(element, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_1.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
  var icon = Companion_getInstance().search_1;
  // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (IconView())(element_0.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element_0.willAddChild_hz2iwc_k$(element_1);
  element_1.set_source_3o5lkf_k$(icon);
  element_1.set_description_s1386w_k$('search');
  element_1.onStartup_vrxh3i_k$();
  element_0.addChild_2qpft2_k$(element_1);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  var this_2 = weight(element_0, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (TextInput())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_2.willAddChild_hz2iwc_k$(element_2);
  element_2.set_accessibleLabel_97wje2_k$('Search');
  // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
  // Inline function 'com.lightningkite.kiteui.views.placeholder' call
  element_2.native_1.attributes_1.native_1.placeholder = 'Search';
  element_2.bind_gesskf_k$(element_2.content_1, search);
  element_2.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_2);
  element_0.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  var tmp$ret$20 = weight(element, 1.0);
  var tmp = get_scrolling(themed(tmp$ret$20, ListSemantic_getInstance()));
  var tmp_0 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$remember.invoke_r7m7el_k$(options);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      if (contains(toString(element), $this$remember.invoke_r7m7el_k$(search), true)) {
        destination.add_utx5q5_k$(element);
      }
    }
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = (a, b) => {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp = toString(a);
      var tmp$ret$28 = toString(b);
      return compareValues(tmp, tmp$ret$28);
    };
    var tmp$ret$25 = new (sam$kotlin_Comparator$0())(tmp);
    return sortedWith(destination, tmp$ret$25);
  });
  colOf(tmp, tmp_0, VOID, VOID, VOID, ($this$colOf, it) => {
    // Inline function 'com.lightningkite.kiteui.views.compact' call
    var this_0 = dynamicThemed($this$colOf, ($this$dynamicThemed) => equals(id($this$dynamicThemed.invoke_r7m7el_k$(it)), $this$dynamicThemed.invoke_r7m7el_k$(selected)) ? SelectedSemantic_getInstance() : UnselectedSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_1 = themed(this_0, CompactSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (Button())(this_1.get_context_h02k06_k$());
    ensureOutermostElement(element);
    this_1.willAddChild_hz2iwc_k$(element);
    var tmp = KMutableProperty0();
    var tmp_0 = Button$_get_accessibleLabel_$ref_o692ls(element);
    var tmp_1 = getPropertyCallableRef('accessibleLabel', 0, tmp, tmp_0, Button$_set_accessibleLabel_$ref_xk4qh0(element));
    element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => toString($this$invoke.invoke_r7m7el_k$(it)));
    row(element, it);
    element.set_action_2ds022_k$(Action('Select', VOID, VOID, VOID, VOID, VOID, singleSelector$lambda$slambda(select, it)));
    element.onStartup_vrxh3i_k$();
    this_1.addChild_2qpft2_k$(element);
    return Unit_instance;
  });
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
}
function HasId$_get__id_$ref_bvv61j() {
  return constructCallableReference((p0) => p0.get__id_18jb1r_k$(), 1, 0, 199);
}
function singleSelectToggleWithId$lambda$slambda($edit, $id, $this_opensMenu) {
  return constructCallableReference((item, $completion) => orPromise($completion, function *($completion) {
    yield* $edit.set_revjhg_k$($id(item), $completion);
    closePopovers($this_opensMenu.get_context_h02k06_k$());
    return Unit_instance;
  }), 1);
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      compare_bczr_k$(a, b) {
        return this.function_1(a, b);
      }
      compare(a, b) {
        return this.compare_bczr_k$(a, b);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function singleSelector$lambda$slambda($select, $it) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $it;
    var tmp$ret$0 = yield* await_0(this_0, $completion);
    yield* $($select(tmp$ret$0, $completion), $completion);
    return Unit_instance;
  }), 1);
}
//region block: exports
export {
  singleSelect as singleSelectsi94opizn1pu,
};
//endregion

//# sourceMappingURL=singleSelectField.mjs.map
